import {Dispatch} from 'react'
import {SUJETO_EXCLUIDO_TYPES} from '../../constants/sujetoExcluido.types'
import {State} from '../../reducers'
import {sujetoExcluidoModalsClose} from './sujetoExcluidoProductos.actions'
import {sujetoExcluidoFormClienteValidacionesGenerarFactura} from './sujetoExcluidoCliente.actions'
import {generalOpenModalError, generalOpenModalInfo, generalOpenModalMessage, generalShowLoader, getFechaHora} from '../general.actions'
import {KEYS} from '../../constants/keysStorage'
import * as http from '../../api/http'
import {ENDPOINTS} from '../../api/config'
import {setDatosGeneralesEmisor} from '../catalogos.actions'
import {getFechaFormato1, getHoraNow} from '../../utils/stringDate'
import {getQR} from '../operaciones/operaciones.actions'
import {sujetoExcluidoFormSucursalValidacion} from './sujetoExcluidoSucursal.actions'
import {SEClienteF, SujetoExcluidoAction} from '../../interfaces/sujeto-excluido.interface'
import {setResultAnulaciones} from '../historial/historial.actions'
import { guardarClienteReceptor } from '../operaciones/clienteReceptor.actions'
import { docsDatosReceptorReset, docsDatosReceptorSiguiente } from '../documentos/documentos.actions'
import { handleRestartStateFormaPago } from '../forma-pago.actions'
import { unirChipsJoin, unirChipsReturnFirst } from '../../utils/strings.utils'

export const sujetoExcluidoClearAll = (flag: boolean = false) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_CLEAR_ALL,
  payload: flag,
})

export const sujetoExcluidoSetDatosEmisor = (emisor: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_DATOS_EMISOR,
  payload: emisor,
})

export const sujetoExcluidoSetDatosFactura = (factura: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_DATOS_FACTURA,
  payload: factura,
})

export const sujetoExcluidoSetFacturaEmitida = (flag: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_FACTURA_EMITIDA,
  payload: flag,
})

export const sujetoExcluidoSetActivarOpciones = () => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_OPCIONES_ACTIVA,
  payload: true,
})

export const sujetoExcluidoSetCatalogoSucursal = (sucursales: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_CATALOGO_SUCURSAL,
  payload: sucursales,
})

export const sujetoExcluidoSetCatalogoSerie = (series: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_CATALOGO_SERIE,
  payload: series,
})

export const sujetoExcluidoSetUUID = (uuid: any) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_SET_UUID,
  payload: uuid,
})

export const sujetoExcluidoAnulado = (flag: boolean) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_ANULADO,
  payload: flag,
})

// ******************************************************************************************
export const sujetoExcluidoSetModalEmitirFactura = (flag: boolean) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALFACTURACION_OPEN,
  payload: {activeEmitirFactura: flag},
})

export const sujetoExcluidoSetModalFacturaEmitida = (flag: boolean) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALFACTURACION_OPEN,
  payload: {activeFacturaEmitida: flag},
})

export const sujetoExcluidoSetModalImpresion = (flag: boolean) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALIMPRESION_OPEN,
  payload: flag,
})

export const sujetoExcluidoSetModalEmail = (flag: boolean) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALEMAIL_OPEN,
  payload: flag,
})

export const sujetoExcluidoSetModalAnular = (flag: boolean) => ({
  type: SUJETO_EXCLUIDO_TYPES.SUJETO_EXCLUIDO_MODALANULAR_OPEN,
  payload: flag,
})

// ******************************************************************************************
// ? FUNCIONES O PROCEDIMIENTOS SIN PETICIONES RES
// ******************************************************************************************
export const sujetoExcluidoClicGenerarFactura =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    if (sujetoExcluidoFormClienteValidacionesGenerarFactura(dispatch, getState)) {
      window.scroll(0, 0)
      const form = {...getState().sujetoExcluido.errorsFormCliente}
      delete form.condicion
      const hasErrors = Object.values(form).some(error => error);
      if (hasErrors) dispatch(generalOpenModalInfo('Datos incorrectos en el formulario Datos del Cliente'))
      return false
    }
    if (sujetoExcluidoFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalInfo('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    const array = getState().sujetoExcluido.arrayProductos
    if (array.length === 0) {
      dispatch(generalOpenModalInfo('Debe agregar al menos un producto para poder Generar la factura'))
      return false
    }
    if(docsDatosReceptorSiguiente(dispatch, getState)) return false
    return true
  }

// ******************************************************************************************
// ? PETICIONES REST
// ******************************************************************************************
export const sujetoExcluidoGetDatosEmisor =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const datos = getState().catalogos.datosEmisor;
    if (datos !== null && Object.keys(datos).length > 0) {
      dispatch(sujetoExcluidoSetDatosEmisor(getState().catalogos.datosEmisor))
      return
    }

    http
      .get(ENDPOINTS.FACTURACION_GET_EMPRESA_EMISOR, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res?.message) return dispatch(generalOpenModalError(res.message))
        const response = {
          ...res.body,
          departamento: {
            idDepartamento: res?.body?.departamento,
            valor: res?.body?.departamentonombre,
          },
          municipio: {
            idMmunicipio: res?.body?.municipio,
            valor: res?.body?.municipionombre,
          },
        }
        dispatch(sujetoExcluidoSetDatosEmisor(response))
        dispatch(setDatosGeneralesEmisor(response))
      })
      .catch((err) => {
        let message = 'No se logró obtener los datos del Emisor'
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
  }

export const sujetoExcluidoPostSucursales =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    const {datos} = getState().userLogin;
    let message = 'No se logró obtener el catalogo de sucursales'
    await http
      .post(ENDPOINTS.FACTURACION_POST_SUCURSALES, {
        idsucursal: `${datos.sucursal_seleccionada}`,
        tipodocumento: '14'
      }, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body && !res.message) {
          const sucursal = res.body;
          const hayDocs = sucursal[0]?.Documento?.length;
          if (!hayDocs) {
            dispatch(sujetoExcluidoSetCatalogoSucursal([]))
          } else {
            dispatch(sujetoExcluidoSetCatalogoSucursal(res.body))
          }
        } else {
          dispatch(generalOpenModalError(res.message || message))
        }
      })
      .catch((err) => {
        if(err?.response?.data?.errorCode === 1) { dispatch(sujetoExcluidoSetCatalogoSucursal([])); return; }
        dispatch(generalOpenModalError(err?.response?.data?.message ?? message, err?.response?.data?.status))
      })
  }

export const sujetoExcluidoGetUUID = (tipoDoc: string | null = null) => async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    let message = 'No se logró obtener el UUID del documento'
    const params = {TipoDOc: tipoDoc || '14'}
    await http
      .get(ENDPOINTS.FACTURACION_GET_UUID, params, KEYS.TOKEN)
      .then(async (res: any) => {
        if (res.body && !res.message) {
          dispatch(sujetoExcluidoSetUUID(res.body))
          return
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err) => {
        dispatch(generalOpenModalError(err?.response?.data?.message || message, err?.response?.data?.status))
      })
  }

export const sujetoExcluidoClicEmitirFactura =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    if (sujetoExcluidoFormClienteValidacionesGenerarFactura(dispatch, getState)) {
      dispatch(generalOpenModalInfo('Datos incorrectos en el formulario Datos del Cliente'))
      return false
    }
    if (sujetoExcluidoFormSucursalValidacion(dispatch, getState)) {
      window.scroll(0, 0)
      dispatch(generalOpenModalInfo('Datos incompletos en el formulario sucursal y serie'))
      return false
    }
    const array = getState().sujetoExcluido.arrayProductos
    if (array.length === 0) {
      dispatch(generalOpenModalInfo('Debe agregar al menos un producto para poder Generar la factura'))
      return false
    }
    if(docsDatosReceptorSiguiente(dispatch, getState)) return false

    dispatch(sujetoExcluidoSetModalEmitirFactura(true))
  }

export const sujetoExcluidoCloseModalEmitir =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    dispatch(sujetoExcluidoSetModalEmitirFactura(false))
  }
/**
 * sujetoExcluidoClicEmitirModal = emite la factura
 * @param history hook useHistory
 * @returns void
 */
export const sujetoExcluidoClicEmitirModal =
  (history: any) => async (dispatch: Dispatch<any>, getState: () => State) => {
    if (getState().general.loader) return
    dispatch(generalShowLoader(true))
    const {formCliente, formSucursal, arrayProductos, calculosArrayProductos, datosUUID} = getState().sujetoExcluido
    const horasActuales:any = await dispatch(getFechaHora());
    const user = localStorage.getItem(KEYS.ID_CLIENT)
    let doc = formCliente.numId?.trim() || ''
    if (formCliente.tipoDocumento === KEYS.DOCUMENTO_DUI_ID && doc.length > 1) doc = `${doc.substring(0,doc.length-1)}-${doc[doc.length-1]}`
    const {unidadesMedida} = getState().catalogos
    const {activeDoc} = getState().documentos
    const datosReceptor = getState().documentos.datosReceptor.form
    const {pagos, formFormaPago} = getState().formaPago
    const userLogin = getState().userLogin


    let body: any = {
      id_user: user,
      facturas: [{
          receptorManual: datosReceptor.nombre,
          docManual: datosReceptor.numId,
          esReceptorManual : datosReceptor.esReceptorManual,
          tipoDocManual : datosReceptor.nombreTipoDocumento,
          idsucursaldocumento: formSucursal?.datosSerie?.idsucursaldocumento,
          receptorEmailsEnvio: unirChipsJoin(formCliente.chipsEmail!, formCliente.email!),
          tipoDte: activeDoc?.idDoc ? activeDoc.idDoc : '14',
          cveDoc: `${formSucursal?.datosSerie?.serie}-${formSucursal?.datosSerie?.numeroactual}`,
          uuid: datosUUID?.CodigoGeneracion,
          fechaDoc: horasActuales ? (`${horasActuales.FechaDDMM} ${horasActuales.Hora}`) : `${getFechaFormato1()} ${getHoraNow()}`,
          canTotal: calculosArrayProductos.totalMontoOperacion!,
          impuTotal: calculosArrayProductos.totalImpuesto1,
          impuTotal2: calculosArrayProductos.totalImpuesto2,
          impuTotal3: calculosArrayProductos.totalIvaPercibido,
          reteRenta: calculosArrayProductos.totalRetencionRenta,
          descuentoTotal: calculosArrayProductos.descuento,
          condicion: formCliente.condicion?.trim() || '',
          condicionOperacion: formFormaPago.condicion,
                    formapago: pagos.map((pago) => {
                        return (
                            {
                                codigo: pago.formaPago,
                                montoPago: parseFloat(pago.monto).toFixed(2),
                                referencia: pago.numeroDocumento || '',
                                plazo: pago.plazo,
                                periodo: pago.periodo
                            }
                        )
                    }),
          cuerpoDocumento: arrayProductos.map((p) => ({
            cantidad: p.cantidad,
            precioUni: p.precio,
            impuesoItem: p.totalImpuesto1,
            impuesoItem2: p.totalImpuesto2,
            impuesto: p.impuesto1,
            impuesto2: p.impuesto2,
            descripcion: p.descripcion?.trim(),
            descuento: p.cantidadDescuento,
            TipoMonto: "0", // tipo monto 0 es gravado y 1 es exento 
            TipoItem: p.tipo === "s" ? "0" : "1",  // tipo item 0 es producto y 1 es servicio 
            unidad: p.unidadMedida,
            codigo: p.clave ?? '',
            descUnidad: unidadesMedida.find((unidad) => unidad.codigo === p.unidadMedida)?.valor || '59'
          })),
          receptor: {
            tipoDocumento: formCliente.tipoDocumento,
            numDocumentoReceptor: doc,
            nombre: formCliente.nombre?.trim(),
            direccion: formCliente.direccion?.trim(),
            email: unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!),
            telefono: formCliente.telefono?.trim(),
            departamento: formCliente.departamento,
            municipio: formCliente.municipio,
          },
        },
      ],
      tokenGateway: localStorage.getItem(KEYS.TOKEN) ?? '',
      tokenHacienda: localStorage.getItem(KEYS.HACIENDA) ?? '',
      idSucursal: userLogin?.datos?.sucursal_seleccionada,
      idEmpresa: `${userLogin?.datos?.codigo_empresa}`
    }
    if(formCliente.tipoDocumento && formCliente.numId) guardarClienteReceptor(formCliente, dispatch)
    let message = 'Se produjo un error al momento de emitir la factura, inténtelo nuevamente.'

    await http
      .post(ENDPOINTS.FACTURACION_POST_RECEPCION_DTE, body, {}, KEYS.TOKEN)
      .then(async (res: any) => {
        if(res?.body?.NuevoToken){localStorage.setItem(KEYS.HACIENDA, res?.body?.TokenHacienda)}
        
        if (res?.body && !res.message) {
          if (res.body?.estado === 'PROCESADO') {
            window.scroll(0, 0)
            await dispatch(sujetoExcluidoSetDatosFactura(res.body))

            const {qr, message: ms} = await getQR(res?.body.JsonFactura)
            if (ms) dispatch(generalOpenModalError(ms))
            dispatch(sujetoExcluidoSetDatosFactura({qr}))

            await dispatch(sujetoExcluidoSetFacturaEmitida(true))
            await dispatch(sujetoExcluidoSetModalFacturaEmitida(true))
            await dispatch(sujetoExcluidoSetModalEmitirFactura(false))
            return
          }
          res.message = mostrarObservacionesError(res?.body?.observaciones, message, history, formCliente, dispatch)
        }
        dispatch(generalOpenModalError(res.message || message))
      })
      .catch((err: any) => {
        err.response.data.message = mostrarObservacionesError(err?.response?.data?.body?.observaciones, err?.response?.data?.body?.descripcionMsg, history, formCliente, dispatch)
        dispatch(generalOpenModalError(err?.response?.data?.message ? err?.response?.data?.message : message, err?.response?.data?.status))
      })
      .finally(() => dispatch(generalShowLoader(false)))
  }

const mostrarObservacionesError = (arrayObservaciones: any, message: string, history: any, formCliente: SEClienteF,dispatch: Dispatch<SujetoExcluidoAction>): string => {
  if (Array.isArray(arrayObservaciones)) {
    const errorMessage = construirErrorMessage(arrayObservaciones, formCliente);
    if (errorMessage) {
      message = errorMessage;
      if (contieneCampoReceptor(arrayObservaciones)) {
        dispatch(sujetoExcluidoSetModalEmitirFactura(false))
        history.push('/emitir-factura/formulario');
      }
    }
  }
  return message;
};
  
const construirErrorMessage = (observaciones: string[], formCliente: SEClienteF): string => {
  let errorMessage = '';
  observaciones.forEach((el: string) => {
    if (el.trim().includes('Campo #/receptor/')) {
      el = el.replaceAll('Campo #/receptor/', 'Formulario con datos del cliente el campo: ');
      errorMessage += `<li>${el} o está vacío.</li>`;
    } else errorMessage += `<li>${el}.</li>`;
  });
  if (errorMessage)  errorMessage = `No se pudo generar la factura, Hacienda solicita llenar los siguientes campos:<br><br><ol>${errorMessage}</ol>`;
  return errorMessage;
};

const contieneCampoReceptor = (observaciones: string[]): boolean => {
  const cadena = 'Campo #/receptor';
  return observaciones.some((el: string) => el.trim().includes(cadena));
};

export const sujetoExcluidoCloseModalFacturaEmitida =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    dispatch(sujetoExcluidoModalsClose())
  }

export const sujetoExcluidoVerDetalleDocumentoEmitido =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    dispatch(sujetoExcluidoSetActivarOpciones())
    dispatch(sujetoExcluidoModalsClose())
  }

export const sujetoExcluidoCloseModalDocumentoEmitida =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
    dispatch(handleRestartStateFormaPago())
    dispatch(sujetoExcluidoClearAll())
    dispatch(docsDatosReceptorReset())
    dispatch(sujetoExcluidoModalsClose())
  }

export const sujetoExcluidoOpenCloseModalImprimir =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    await dispatch(sujetoExcluidoSetModalImpresion(flag))
    await dispatch(sujetoExcluidoSetModalFacturaEmitida(!flag))
  }

export const sujetoExcluidoOpenCloseModalEmail =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    await dispatch(sujetoExcluidoSetModalEmail(flag))
    await dispatch(sujetoExcluidoSetModalFacturaEmitida(!flag))
  }

export const sujetoExcluidoOpenMasOpciones =
  () => async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    await dispatch(sujetoExcluidoSetActivarOpciones())
    await dispatch(sujetoExcluidoSetModalFacturaEmitida(true))
  }

export const sujetoExcluidoOpenCloseModalAnular =
  (flag: boolean = false) =>
  async (dispatch: Dispatch<SujetoExcluidoAction>) => {
    await dispatch(sujetoExcluidoSetModalAnular(flag))
    await dispatch(sujetoExcluidoSetModalFacturaEmitida(false))
  }

export const sujetoExcluidoVerificarAnulacion = (funcionRedirigir: () => void) => async (dispatch: Dispatch<SujetoExcluidoAction>, getState: () => State) => {
  const {resultAnulaciones} = getState().historial
  const anulado = getState().sujetoExcluido.anulado

  // Anulacion unitaria
  if (!anulado) {
    dispatch(sujetoExcluidoAnulado(resultAnulaciones[0].result))
    if (resultAnulaciones[0].result) {
      dispatch(generalOpenModalMessage("Documento anulado", "El documento ha sido anulado exitosamente."))
      funcionRedirigir()
      dispatch(setResultAnulaciones([]))
      return
    }
    else dispatch(generalOpenModalError(resultAnulaciones[0].msg))
  }

  dispatch(setResultAnulaciones([]))
  await dispatch(sujetoExcluidoSetModalAnular(false))
  await dispatch(sujetoExcluidoSetModalFacturaEmitida(true))
}